import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  NgxMaskDirective,
  provideNgxMask
} from 'ngx-mask';
import { ToastrService } from 'ngx-toastr';
import { CardModule } from 'primeng/card';
import { InitService } from '../../shared/services/init.service';
import { PeopleService } from '../../shared/services/people.service';

@Component({
  selector: 'app-init-page',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective,
  ],
  providers: [provideNgxMask()],
  templateUrl: './init-page.component.html',
  styleUrl: './init-page.component.scss',
})
export class InitPageComponent {
  public iconSrc: string = '';    
  constructor(
    private router: Router,
    private service: PeopleService,
    private fb: FormBuilder,
    private toast: ToastrService,
    private initService: InitService,
  ) {
    // Tenant config should be loaded via APP_INITIALIZER, but add safety check
    if (this.initService.tenantConfig) {
      this.iconSrc = this.initService.tenantConfig.iconUrl;
    } else {
      console.warn('Tenant config not available despite APP_INITIALIZER - loading now...');
      // Fallback: load config manually if APP_INITIALIZER failed
      this.initService.init().subscribe({
        next: (config) => {
          this.iconSrc = config.iconUrl;
        },
        error: (error) => {
          console.error('Fallback: Error loading tenant config:', error);
          this.iconSrc = ''; // Set empty string to avoid template errors
        }
      });
    }
  }
  loading: boolean = false;
  legalPersonForm = this.fb.group({
    documentNumber: [
      '',
      Validators.compose([
        Validators.required,
        Validators.minLength(11),
        Validators.maxLength(14),
      ]),
    ],
  });

  accountId: string | null = null;

  onImageError(event: any) {
    console.error('Error loading image:', event);
    // You could set a fallback image here
    // this.iconSrc = '/assets/images/default-logo.png';
  }

  getMonthList() {
    this.loading = true;
    if (this.legalPersonForm.valid) {
      this.service
        .checkDocumentExists(
          this.legalPersonForm.controls.documentNumber.value!
        )
        .subscribe({
          next: (res) => {
            if (res)
              this.router.navigateByUrl(`select-month/${res.id}/${res.name}`);
            this.loading = false;
          },

          error: (err) => {
            this.toast.error('Usuário e/ou senha inválidos.');
            this.loading = false;
          },
        });
    }
  }
}
